import React, {Component} from 'react';
import couterpart from 'counterpart';

import ItemDataService from '../services/ItemDataService';
import ItemImageViewer from './ItemImageViewer';
import AuthenticationService from '../services/AuthenticationService';

import '../css/formStyle.css';

class ItemDetailsViewById extends Component {
    constructor() {
        super();
        this.state = {
            item: {},
            images: []
        } 
    };


    componentDidMount () {
        if ((this.props.itemSku === null) || (this.props.itemSku === undefined) || 
            (this.props.itemSku.length < 1)){
                return;
            }

        ItemDataService.retrieveBySku2(this.props.itemSku).then(data => {
          this.setState({ item:  data}, ()=>{
            if ((this.state.item.id === undefined) || (this.state.item.id === null)){
                return;
            }
            ItemDataService.retrieveImagesOfItem(this.state.item.id).then(data => {
                this.setState({ images:  data});
            });
          })
        });
    }

    render() {
        if (AuthenticationService.isUser() || AuthenticationService.isWorker()){
            return (<div>&nbsp;</div>)
        }

        return (
            <div className="col-12">
                <div className="row">
                    <div className="col-4 border-left border-top border-light-gray"><b>{couterpart.translate('item_sku')}</b></div>
                    <div className="col-8 border-left border-top border-right border-light-gray">{this.state.item.sku}</div>
                </div>
                <div className="row">
                    <div className="col-4 border-left border-top border-light-gray"><b>{couterpart.translate('item_description')}</b></div>
                    <div className="col-8 border-left border-top border-right border-light-gray">{this.state.item.description}</div>                
                </div>
                <div className="row">
                    <div className="col-4 border-left border-top border-light-gray"><b>{couterpart.translate('item_size')}</b></div>
                    <div className="col-8 border-left border-top border-right border-light-gray">{this.state.item.lengthSize}</div>
                </div>
                <div className="row">               
                    <div className="col-12 border border-light-gray">
                        <ItemImageViewer caption={couterpart.translate('item_images_title')} 
                                        images={this.state.images}/><br/>
                    </div>
                </div>               
            </div>
        );
    }
}

export default ItemDetailsViewById;